// Százalék-formázás — NYELVFÜGGŐ tizedesjellel (user-döntés): magyarul vessző („73,9%"), angolul pont („73.9%").
// A pénz-formázó (`format-money.ts`) mintájára a felület nyelvét kapja (`i18n.language`), és az `Intl`-re bízza a
// tizedesjelet — kézzel összerakott `toFixed()` + „%" a felület nyelvétől függetlenül mindig pontot írt.
//
// A `value` MÁR százalék (73.9 → „73,9%"), nem arány. Csak MEGJELENÍTÉS: az aránynál nincs pénz-pontossági kérdés.

const EM_DASH = '—';

/**
 * @param fractionDigits a tizedesek száma (alapból 1); egész százaléknál 0.
 * @param signed `true` → pozitív értéknél is előjel („+12,5%") — a változás-jelzőkhöz.
 */
export function formatPercent(
  value: number | null | undefined,
  locale = 'hu-HU',
  { fractionDigits = 1, signed = false }: { fractionDigits?: number; signed?: boolean } = {},
): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return EM_DASH;
  const num = value.toLocaleString(locale, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
    ...(signed ? { signDisplay: 'exceptZero' as const } : {}),
  });
  return `${num}%`;
}
